module.exports = __webpack_public_path__ + "static/media/cactus.ef557f32.svg";